import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down",
  "use": "down-usage",
  "viewBox": "0 0 90 92",
  "content": "<symbol fill=\"currentColor\" viewBox=\"0 0 90 92\" id=\"down\">\n  <path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M47.795 66.69 79.99 34.495l-2.3-2.3-32.195 32.196L13.3 32.195l-2.3 2.3L43.195 66.69l2.3 2.3 2.3-2.3Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol